import React from 'react';
import PropTypes from 'prop-types';

import {
  USER_DEFAULT_AVATAR_URL,
}          from 'app/constants';
import cdn from 'app/helpers/cdn';

class EmpImage extends React.PureComponent {

  render() {
    const size = this.props.size;
    const person = this.props.employee || this.props.user;
    const isEmp = !!this.props.employee;
    const isUser = !isEmp && !!this.props.user;
    const isDefault = !person?.avatarUrl;
    const src = isDefault
      ? USER_DEFAULT_AVATAR_URL
      : cdn.imgUrl(person?.avatarUrl, {width: (size * 2), height: (size * 2), fit: 'cover'});
    const defaultClass = isDefault ? 'default' : 'uploaded';
    const alt = (() => {
      if (!person) return isEmp ? 'Team Member' : 'Someone';
      if (person.firstName && person.lastName) return `${person.firstName} ${person.lastName}`;
      return isEmp ? person.email : 'Someone';
    })();

    return <img className={`ca-emp-img ${defaultClass} size-${size} ${this.props.className}`} src={src} alt={alt} />;
  }

}

EmpImage.propTypes = {
  employee: PropTypes.object,
  user: PropTypes.object,
  size: PropTypes.number,
  className: PropTypes.string,
};
EmpImage.defaultProps = {
  employee: null,
  user: null,
  size: 22,
  className: '',
};

export default EmpImage;
